import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';

import {EngineAction, SearchResult} from '../../../model/Search';
import {ExecuteEngineAction} from '../../../store/partials/SearchEngines';

import * as Styles from './EngineSearchResultEntry.module.scss';

interface Props {
    item: SearchResult;
    executeEngineAction: (searchEngineAction: EngineAction) => void;
}

function getActionText(action: EngineAction): string | undefined {
    switch (action?.type) {
        case 'application':
            return action.manifestUrl;
        case 'browser':
            return action.url;
        case 'intent':
            return action.intent;
        default:
            return undefined;
    }
}

export const EngineSearchResultEntryComponent = React.forwardRef<HTMLElement, Props>((props, ref) => {
    const {executeEngineAction, item} = props;
    const {action, title, description} = item;
    const actionText = getActionText(action);
    const handleClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        executeEngineAction(action);
    };

    return (
        <div className={Styles['result']} ref={ref as React.Ref<HTMLDivElement>} onClick={handleClick}>
            <div className={Styles['title']}>{title}</div>
            {actionText !== undefined && <div className={Styles['action']}>{actionText}</div>}
            <div className={Styles['description']}>{description}</div>
        </div>
    );
});

const mapDispatch = (dispatch: Dispatch) => ({
    executeEngineAction: (searchEngineAction: EngineAction) => dispatch(new ExecuteEngineAction(searchEngineAction))
});

export const EngineSearchResultEntry = connect(undefined, mapDispatch, undefined, {forwardRef: true})(EngineSearchResultEntryComponent);
